import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { t, getLang } from "@/lib/i18n";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const lang = getLang();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/categories");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <Layout>
      <div className="max-w-md mx-auto px-6 py-16 fade-in">
        <h1 className="font-serif text-4xl font-medium mb-2">{t(lang, "login")}</h1>
        <p className="text-muted-foreground mb-8 text-sm">Continue where you left off.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="email">{t(lang, "email")}</Label>
            <Input id="email" data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" />
          </div>
          <div>
            <Label htmlFor="password">{t(lang, "password")}</Label>
            <Input id="password" data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" />
          </div>
          <Button type="submit" data-testid="login-submit" className="w-full bg-[hsl(var(--accent))] hover:bg-[hsl(var(--accent))]/90 h-11 rounded-full" disabled={busy}>
            {busy ? "..." : t(lang, "login")}
          </Button>
          <p className="text-sm text-muted-foreground text-center">
            New student? <Link to="/apply" className="underline text-foreground" data-testid="link-apply">Apply for admission</Link>
          </p>
        </form>
      </div>
    </Layout>
  );
}
